import React from "react";
import { Icon } from "@iconify/react";
import Button from "../../shared/button";
import Badge from "../../shared/badge";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

const Works = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <div className="w-full bg-white" id="how-it-works">
      <div className="flex flex-col lg:flex-row items-center justify-between w-[80%] max-xxxl:w-[90%] m-auto py-[46px] pb-[96px]">
        {/* Left Section - Image */}
        <div className="w-full lg:w-1/2 mb-8 lg:mb-0">
          <img
            src="../../assets/images/home/worksBg.png"
            alt="Chatbot Apollo AI"
            className="w-full h-full max-h-[643px] drop-shadow-lg"
          />
        </div>

        {/* Right Section - Text Content */}
        <div className="w-full lg:w-1/2 lg:pl-12">
          <Badge txt={t("home.works.subtitle")} />

          {/* Title */}
          <h2 className="leading-[60px] tracking-[-3px] max-w-[524px] font-sora">
            {t("home.works.title")}
          </h2>

          {/* Features List */}
          <ul className="space-y-[40px] mt-[40px]">
            <li className="flex flex-col items-start">
              <div className="flex items-center gap-[15px]">
                <Icon
                  color="#00BBDD"
                  icon="simple-line-icons:check"
                  width={20}
                  height={20}
                />
                <h6 className="font-semibold leading-[35px] font-manrope">
                  {t("home.works.steps.step1.title")}
                </h6>
              </div>

              <p className="large txt-color tracking-[-0.72px] font-manrope max-w-[511px] pl-[35px]">
                {t("home.works.steps.step1.description")}
              </p>
            </li>

            <li className="flex flex-col items-start">
              <div className="flex items-center gap-[15px]">
                <Icon
                  color="#00BBDD"
                  icon="simple-line-icons:check"
                  width={20}
                  height={20}
                />
                <h6 className="font-semibold leading-[35px] font-manrope">
                  {t("home.works.steps.step2.title")}
                </h6>
              </div>

              <p className="large txt-color tracking-[-0.72px] font-manrope max-w-[511px] pl-[35px]">
                {t("home.works.steps.step2.description")}
              </p>
            </li>

            <li className="flex flex-col items-start">
              <div className="flex items-center gap-[15px]">
                <Icon
                  color="#00BBDD"
                  icon="simple-line-icons:check"
                  width={20}
                  height={20}
                />
                <h6 className="font-semibold leading-[35px] font-manrope">
                  {t("home.works.steps.step3.title")}
                </h6>
              </div>

              <p className="large txt-color tracking-[-0.72px] font-manrope max-w-[511px] pl-[35px]">
                {t("home.works.steps.step3.description")}
              </p>
            </li>
          </ul>

          {/* Get Started Button */}
          <div className="mt-[50px] pl-[35px]">
            <Button
              text={t("home.works.steps.button")}
              className="button btn-primary"
              height={50}
              width={175}
              onClick={() => {
                navigate("/login");
              }}
            ></Button>
          </div>
        </div>
      </div>
      {/* <h1 className="mt-[40px] uppercase text-center pb-[34px] font-sora max-xxxl:px-[20px] max-xxxl:text-[50px] max-sm:!text-[40px]">
        Artificial Intelligence in shape
      </h1> */}
    </div>
  );
};

export default Works;
